export default __webpack_public_path__ + "static/AccessManagement-765ba794c0d79f2051ab3313702734cd.jpg";